// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wordApp_etLs4 {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 450px;
  height: 250px;
  font-family: Arial, sans-serif;
  margin: 0 auto;
}

.toolbar_CYpEw {
  display: flex;
  padding: 4px 0px;
  background-color: transparent;
  border-bottom: 1px solid var(--dddddd-border);
  gap: 2px;
  padding-left: 2px;
  overflow-x: scroll;
}

.toolbar_CYpEw::-webkit-scrollbar {
  height: 4px;
}

.toolbar_CYpEw::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 12px;
}

.toolbar_CYpEw::-webkit-scrollbar-thumb {
  background-color: #d4d4d4;
  border-radius: 12px;
}

.toolGroup_vYru5 {
  display: flex;
  align-items: center;
  border-right: 0px solid var(--dddddd-border);
  padding-right: 0px;
  position: relative;
  margin: 0px;
  background: var(--f4-background);
  border-radius: 4px;
}

.colorLabel_hHiSF {
  display: flex;
  align-items: center;
}

.toolGroup_vYru5:last-child {
  border-right: none;
}

.toolButton__ycOf {
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--f4-background);
  border: 0px solid var(--dddddd-border);
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  font-size: 12px;
}

.toolButton__ycOf:hover {
  background-color: var(--_e6-color);
}

.toolButton__ycOf.active_beanY {
  background-color: #10a37e62;
  color: var(--white-color);
}

.fontSelect_wpJI5,
.sizeSelect_CFyrb {
  height: 25px;
  width: 34px;
  border: 0px solid var(--dddddd-border);
  border-radius: 4px;
  padding: 0 3px;
  font-size: 12px;
  max-width: 100px;
  background-color: var(--f4-background);
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.sizeSelect_CFyrb:focus {
  outline: 1px solid var(--dddddd-border);
}

.colorPicker_yYw5Y {
  height: 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  padding: 0;
  vertical-align: middle;
  width: 25px;
}

.editor_N6aDt {
  flex: 1 1;
  padding: 15px;
  background-color: var(--f4-background);
  margin: 0px;
  overflow-y: auto;
  outline: none;
  max-width: 480px;
}

.autoResize_d7RKY{
  flex: none;
  max-height: 300px;
}

.emojiPickerPopup_B99UH {
  position: absolute;
  top: 30px;
  right: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  background-color: var(--white-color);
  border: 1px solid var(--dddddd-border);
  border-radius: 4px;
  padding: 5px;
  width: 150px;
  box-shadow: 0 2px 10px var(--_0000001a-shadow);
  z-index: 1000;
}

.emojiButton_RpsWB {
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--white-color);
  border: 1px solid var(--dddddd-border);
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.fontSelect_wpJI5 {
  display: flex;
  align-items: center;
  gap: 3px;
  width: 100px;
}

.fontSelect_wpJI5:focus {
  outline: 1px solid var(--dddddd-border);
}

.emojiButton_RpsWB:hover {
  background-color: var(--_e6-color);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/TelamatelFormAutomate/MiniWordDocs/MiniWordDocs.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,6CAA6C;EAC7C,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sCAAsC;EACtC,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".wordApp {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 450px;\n  height: 250px;\n  font-family: Arial, sans-serif;\n  margin: 0 auto;\n}\n\n.toolbar {\n  display: flex;\n  padding: 4px 0px;\n  background-color: transparent;\n  border-bottom: 1px solid var(--dddddd-border);\n  gap: 2px;\n  padding-left: 2px;\n  overflow-x: scroll;\n}\n\n.toolbar::-webkit-scrollbar {\n  height: 4px;\n}\n\n.toolbar::-webkit-scrollbar-track {\n  background-color: transparent;\n  border-radius: 12px;\n}\n\n.toolbar::-webkit-scrollbar-thumb {\n  background-color: #d4d4d4;\n  border-radius: 12px;\n}\n\n.toolGroup {\n  display: flex;\n  align-items: center;\n  border-right: 0px solid var(--dddddd-border);\n  padding-right: 0px;\n  position: relative;\n  margin: 0px;\n  background: var(--f4-background);\n  border-radius: 4px;\n}\n\n.colorLabel {\n  display: flex;\n  align-items: center;\n}\n\n.toolGroup:last-child {\n  border-right: none;\n}\n\n.toolButton {\n  width: 25px;\n  height: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--f4-background);\n  border: 0px solid var(--dddddd-border);\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: bold;\n  font-size: 12px;\n}\n\n.toolButton:hover {\n  background-color: var(--_e6-color);\n}\n\n.toolButton.active {\n  background-color: #10a37e62;\n  color: var(--white-color);\n}\n\n.fontSelect,\n.sizeSelect {\n  height: 25px;\n  width: 34px;\n  border: 0px solid var(--dddddd-border);\n  border-radius: 4px;\n  padding: 0 3px;\n  font-size: 12px;\n  max-width: 100px;\n  background-color: var(--f4-background);\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\n.sizeSelect:focus {\n  outline: 1px solid var(--dddddd-border);\n}\n\n.colorPicker {\n  height: 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  padding: 0;\n  vertical-align: middle;\n  width: 25px;\n}\n\n.editor {\n  flex: 1;\n  padding: 15px;\n  background-color: var(--f4-background);\n  margin: 0px;\n  overflow-y: auto;\n  outline: none;\n  max-width: 480px;\n}\n\n.autoResize{\n  flex: none;\n  max-height: 300px;\n}\n\n.emojiPickerPopup {\n  position: absolute;\n  top: 30px;\n  right: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n  background-color: var(--white-color);\n  border: 1px solid var(--dddddd-border);\n  border-radius: 4px;\n  padding: 5px;\n  width: 150px;\n  box-shadow: 0 2px 10px var(--_0000001a-shadow);\n  z-index: 1000;\n}\n\n.emojiButton {\n  width: 25px;\n  height: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--white-color);\n  border: 1px solid var(--dddddd-border);\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.fontSelect {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  width: 100px;\n}\n\n.fontSelect:focus {\n  outline: 1px solid var(--dddddd-border);\n}\n\n.emojiButton:hover {\n  background-color: var(--_e6-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wordApp": `wordApp_etLs4`,
	"toolbar": `toolbar_CYpEw`,
	"toolGroup": `toolGroup_vYru5`,
	"colorLabel": `colorLabel_hHiSF`,
	"toolButton": `toolButton__ycOf`,
	"active": `active_beanY`,
	"fontSelect": `fontSelect_wpJI5`,
	"sizeSelect": `sizeSelect_CFyrb`,
	"colorPicker": `colorPicker_yYw5Y`,
	"editor": `editor_N6aDt`,
	"autoResize": `autoResize_d7RKY`,
	"emojiPickerPopup": `emojiPickerPopup_B99UH`,
	"emojiButton": `emojiButton_RpsWB`
};
export default ___CSS_LOADER_EXPORT___;
